import { NotAuthorizedError } from '../types'

export function notAuthorized(options: NotAuthorizedError) {
	;(options as any).isNotAuthorized = true
	if (options.throw) { throw options }
	return options
}

export function isNotAuthorized(obj: any): obj is NotAuthorizedError {
	return !!obj?.isNotAuthorized
}
